<div class="container mx-auto px-4" [class.dark]="themeService.isDark()">
  
    <!-- Calculator Form -->
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">

      <!-- Input Section -->
      <div class="bg-white dark:bg-gray-800 dark:bg-gray-800 rounded-xl shadow-lg p-8">
        <h2 class="text-2xl font-bold text-gray-900 dark:text-white dark:text-white mb-6">Input Parameters</h2>

        <form [formGroup]="moneyRunForm" class="space-y-6">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">

            <!-- Left Column -->
            <div class="space-y-4">
              <!-- Future Growth Rate -->
              <div>
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  Future Growth Rate (%)
                </label>
                <div class="relative">
                  <input
                    type="number"
                    formControlName="growthRate"
                    placeholder="Enter growth rate"
                    step="0.01"
                    min="2"
                    max="50"
                    class="w-full px-3 py-2 pr-8 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                  />
                  <span class="absolute right-3 top-2.5 text-gray-500 dark:text-gray-400 text-sm">%</span>
                </div>
                <small class="text-gray-500 dark:text-gray-400 mt-1">Expected annual growth rate</small>

                <!-- Growth Rate Warning -->
                <div *ngIf="moneyRunForm.get('growthRate')?.value > 15" class="mt-2 p-3 bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-lg">
                  <div class="flex items-start">
                    <svg class="w-5 h-5 text-yellow-600 dark:text-yellow-400 mr-2 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                      <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path>
                    </svg>
                    <p class="text-yellow-800 dark:text-yellow-200 text-sm">Growth rates above 15% are typically not sustainable long-term. Consider using a more conservative estimate.</p>
                  </div>
                </div>
              </div>

               <!-- Target Years to Pay Off -->
              <div>
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  Target Years to Pay Off
                </label>
                <div class="relative flex">
                  <button
                    type="button"
                    class="flex-shrink-0 bg-gray-100 dark:bg-gray-600 hover:bg-gray-200 dark:hover:bg-gray-500 inline-flex items-center justify-center border border-gray-300 dark:border-gray-600 rounded-l-lg px-3 h-11 focus:ring-gray-100 focus:ring-2 focus:outline-none"
                    (click)="decrementTargetYears()">
                    <svg class="w-3 h-3 text-gray-900 dark:text-white" fill="none" stroke="currentColor" viewBox="0 0 18 2">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 1h16"/>
                    </svg>
                  </button>
                  <input
                    type="number"
                    formControlName="targetYears"
                    placeholder="Enter target years"
                    min="1"
                    max="30"
                    class="bg-gray-50 dark:bg-gray-700 border-x-0 border-gray-300 dark:border-gray-600 h-11 text-center text-gray-900 dark:text-white text-sm focus:ring-blue-500 focus:border-blue-500 block w-full py-2.5"
                  />
                  <button
                    type="button"
                    class="flex-shrink-0 bg-gray-100 dark:bg-gray-600 hover:bg-gray-200 dark:hover:bg-gray-500 inline-flex items-center justify-center border border-gray-300 dark:border-gray-600 rounded-r-lg px-3 h-11 focus:ring-gray-100 focus:ring-2 focus:outline-none"
                    (click)="incrementTargetYears()">
                    <svg class="w-3 h-3 text-gray-900 dark:text-white" fill="none" stroke="currentColor" viewBox="0 0 18 18">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 1v16M1 9h16"/>
                    </svg>
                  </button>
                </div>
                <small class="text-gray-500 dark:text-gray-400 mt-1">Years to payoff company with free cash flow (default: 8 years)</small>
              </div>

            </div>

            <!-- Right Column -->
            <div class="space-y-4">

               <!-- Free Cash Flow Per Share -->
              <div>
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  Free Cash Flow Per Share
                </label>
                <div class="relative">
                  <span class="absolute left-3 top-2.5 text-gray-500 dark:text-gray-400 text-sm">$</span>
                  <input
                    type="number"
                    formControlName="fcfPerShare"
                    placeholder="Enter FCF per share"
                    step="0.01"
                    min="0"
                    class="w-full pl-8 pr-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                  />
                </div>
                <small class="text-gray-500 dark:text-gray-400 mt-1">Free cash flow divided by shares outstanding</small>
              </div>
            </div>
          </div>

          <!-- Calculate Button -->
          <div class="pt-4">
            <button
              type="button"
              class="w-full text-white bg-green-700 hover:bg-green-800 focus:ring-4 focus:ring-green-300 font-medium rounded-lg text-lg px-5 py-3 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
              [disabled]="moneyRunForm.invalid || isLoading()"
              (click)="calculateMoneyRun()">
              <svg *ngIf="isLoading()" class="animate-spin w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              {{ isLoading() ? 'Calculating...' : 'Calculate' }}
            </button>
          </div>

          <!-- Clear Button -->
          <div>
            <button
              type="button"
              class="w-full text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-700 focus:ring-4 focus:ring-gray-300 font-medium rounded-lg text-lg px-5 py-3 flex items-center justify-center"
              (click)="clearForm()">
              <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
              </svg>
              Clear All
            </button>
          </div>

        </form>
      </div>

      <!-- Results Section -->
      <div class="bg-white dark:bg-gray-800 rounded-xl shadow-lg p-8">
        <h2 class="text-lg font-bold text-gray-900 dark:text-white mb-6">Calculation Results</h2>

        <!-- Results Display -->
        <div *ngIf="isCalculated; else noResults">

          <!-- Buy Price Result -->
          <div class="calculation-result rounded-lg p-6 mb-6 text-center">
            <h3 class="text-lg font-semibold text-gray-700 dark:text-gray-300 mb-2">Buy Price<br/>(50% Discount)</h3>
            <div class="result-highlight">${{ results.buyPrice | number:'1.2-2' }}</div>
            <p class="text-gray-600 dark:text-gray-400 mt-2">Maximum price to pay to for a cash flow payoff in {{ moneyRunForm.get('targetYears')?.value  }} years</p>
          </div>

          <!-- Sticker Price Result -->
          <div class="bg-gradient-to-r from-green-50 to-blue-50 dark:from-green-900/20 dark:to-blue-900/20 rounded-lg p-6 mb-6 text-center border border-green-200 dark:border-green-800">
            <h3 class="text-lg font-semibold text-gray-700 dark:text-gray-300 mb-2">Sticker Price<br/>(Fair Value)</h3>
            <div class="text-3xl font-bold text-green-600 dark:text-green-400">${{ results.stickerPrice | number:'1.2-2' }}</div>
            <p class="text-gray-600 dark:text-gray-400 mt-2">Fair Value based on cash flow analysis</p>
          </div>

          <!-- Calculation Details -->
          <div class="bg-gray-50 dark:bg-gray-700 rounded-lg p-6 mb-6">
            <h3 class="text-lg font-semibold text-gray-800 dark:text-white mb-4">Calculation Details</h3>
            <div class="space-y-2 text-sm">
              <div class="flex justify-between">
                <span class="text-gray-600 dark:text-gray-400">Growth Rate:</span>
                <span class="font-medium text-gray-900 dark:text-white">{{ moneyRunForm.get('growthRate')?.value }}%</span>
              </div>
              <div class="flex justify-between">
                <span class="text-gray-600 dark:text-gray-400">FCF Per Share:</span>
                <span class="font-medium text-gray-900 dark:text-white">${{ moneyRunForm.get('fcfPerShare')?.value | number:'1.2-2' }}</span>
              </div>
              <div class="flex justify-between">
                <span class="text-gray-600 dark:text-gray-400">Target Years:</span>
                <span class="font-medium text-gray-900 dark:text-white">{{ moneyRunForm.get('targetYears')?.value }} years</span>
              </div>
              <div class="flex justify-between">
                <span class="text-gray-600 dark:text-gray-400">Cash Flow Yield:</span>
                <span class="font-medium text-gray-900 dark:text-white">{{ results.cashFlowYield | number:'1.1-1' }}%</span>
              </div>
            </div>
          </div>

          <!-- Investment Analysis -->
          <div class="bg-gradient-to-r from-yellow-50 to-orange-50 dark:from-yellow-900/20 dark:to-orange-900/20 rounded-lg p-6 border border-yellow-200 dark:border-yellow-800">
            <h3 class="text-lg font-semibold text-orange-800 dark:text-orange-300 mb-3">
              <i class="pi pi-chart-line mr-2"></i>Cash Flow Analysis
            </h3>
            <p class="text-gray-700 dark:text-gray-300 leading-relaxed">{{ results.analysis }}</p>
          </div>

        </div>

        <!-- No Results Template -->
        <ng-template #noResults>
          <div class="text-center py-12">
            <i class="pi pi-dollar text-6xl text-gray-300 dark:text-gray-600 mb-4"></i>
            <p class="text-gray-500 dark:text-gray-400 text-lg">Enter parameters and click "Calculate" to see how Money A Run to see results</p>
          </div>
        </ng-template>
      </div>
    </div>

    <!-- Information Section -->
    <div class="mt-12 bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8">
      <h2 class="text-2xl font-bold text-gray-800 dark:text-white mb-6">About Money A Run Calculator</h2>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div>
          <h3 class="text-lg font-semibold text-gray-700 dark:text-gray-300 mb-3">Free Cash Flow Analysis</h3>
          <p class="text-gray-600 dark:text-gray-400 mb-4">
            This calculator helps you determine how long it takes to payoff your investment through steady cash flows.
            Perfect for evaluating cash-rich, consistent companies that generate reliable free cash flow.
          </p>
        </div>
        <div>
          <h3 class="text-lg font-semibold text-gray-700 dark:text-gray-300 mb-3">Great For</h3>
          <ul class="text-gray-600 dark:text-gray-400 space-y-2">
            <li class="flex items-start">
              <i class="pi pi-check text-blue-500 mr-2 mt-1"></i>
              <span><strong>Mature Companies:</strong> Established businesses with steady cash generation</span>
            </li>
            <li class="flex items-start">
              <i class="pi pi-check text-blue-500 mr-2 mt-1"></i>
              <span><strong>Dividend Stocks:</strong> Companies that return cash to shareholders</span>
            </li>
            <li class="flex items-start">
              <i class="pi pi-check text-blue-500 mr-2 mt-1"></i>
              <span><strong>Utility Stocks:</strong> Consistent cash flow generators</span>
            </li>
            <li class="flex items-start">
              <i class="pi pi-check text-blue-500 mr-2 mt-1"></i>
              <span><strong>REITs:</strong> Real estate investment trusts with predictable income</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
</div>

